import { render, staticRenderFns } from "./reserveClass.vue?vue&type=template&id=450d8bab&"
import script from "./reserveClass.vue?vue&type=script&lang=js&"
export * from "./reserveClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports